var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"positionRelative"},[_c('div',{staticClass:"page success"},[_c('h2',[_vm._v(_vm._s(_vm.__('page_success.title')))]),_c('div',{staticClass:"elementInfo"},[_c('span',[_vm._v(_vm._s(_vm.__('page_success.text')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }